export default __webpack_public_path__ + "static/media/0.ae4dfd98.jpg";